// import React, { useEffect } from "react";
// import "./App.css";
// import { AppRouter, HomeRouter } from "./AppRouter";
// import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { selectAppIsLoading } from "./store/slices/app/selectors";
// import AppLoader from "./views/AppLoader/AppLoader";
// import { setAccessToken, setUser } from "./store/slices/auth/authSlice";
// import { useNavigate } from "react-router-dom";
// import { SnackbarProvider } from "notistack";

// const theme = createTheme({
//   palette: {
//     primary: {
//       main: "#08C2F3",
//       dark: "#00b7e9",
//       contrastText: "#fff",
//     },
//     action: {
//       disabledBackground: "#E6F9FE",
//       disabled: "#FFFFFF",
//     },
//   },
//   components: {
//     MuiFormHelperText: {
//       styleOverrides: {
//         root: {
//           color: "red",
//         },
//       },
//     },
//   },
// });

// function App() {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const queryParams = new URLSearchParams(location.search);
//   const isAppLoading = useSelector(selectAppIsLoading);

//   useEffect(() => {
//     const token = queryParams.get("token");
//     const userId = queryParams.get("userid");
//     if (token && userId) {
//       dispatch(setAccessToken(token));
//       dispatch(setUser({ id: parseInt(userId) }));
//       navigate("/");
//     }
//   }, []);

//   return (
//     <ThemeProvider theme={theme}>
//       <CssBaseline />
//       <SnackbarProvider maxSnack={3}>
//         {isAppLoading && <AppLoader />}
//         <AppRouter />
//         <HomeRouter />
//       </SnackbarProvider>
//     </ThemeProvider>
//   );
// }

// export default App;

import React, { useEffect } from "react";
import { AppRouter } from "./AppRouter";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { selectAppIsLoading } from "./store/slices/app/selectors";
import AppLoader from "./views/AppLoader/AppLoader";
import { setAccessToken, setUser } from "./store/slices/auth/authSlice";
import { selectCurrentUser } from "./store/slices/auth/selectors";
import { useNavigate } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { clearBringBackCart } from "./store/slices/storage/storageSlice";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";

const theme = createTheme({
  palette: {
    primary: {
      main: "#08C2F3",
      dark: "#00b7e9",
      contrastText: "#fff",
    },
    action: {
      disabledBackground: "#E6F9FE",
      disabled: "#FFFFFF",
    },
  },
  components: {
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          color: "red",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          padding: "0 !important",
        },
      },
    },
  },
});

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const currentUser = useSelector(selectCurrentUser);

  useEffect(() => {
    const token = queryParams.get("token");
    const userId = queryParams.get("userid");
    
    if (token && userId) {
      const incomingUserId = parseInt(userId);
      const isNewUser = !currentUser || currentUser.id !== incomingUserId;

      if (isNewUser) {
        // Only clear data if it's a different user
        localStorage.clear();

        // Explicitly clear the bring back cart in Redux store
        dispatch(clearBringBackCart());
      }

      // Set authentication data
      dispatch(setAccessToken(token));
      dispatch(setUser({ id: incomingUserId }));

      navigate("/");
    }
  }, [currentUser]);

  const isAppLoading = useSelector(selectAppIsLoading);
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        {isAppLoading && <AppLoader />}
        <AppRouter />
        <ScrollToTopButton />
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App;